import type { UuidPreset } from "../types/printer.types";

/**
 * Known BLE UUID presets for VSC MP-58M Pro and related 58mm thermal printers.
 * Try them in order — the first matching preset for your unit will work consistently.
 */
export const UUID_PRESETS: UuidPreset[] = [
  {
    name: "VSC MP-58X / MP-58A series",
    description: "Try first — covers most VSC MP-58 variants",
    serviceUuid: "000018f0-0000-1000-8000-00805f9b34fb",
    characteristicUuid: "00002af1-0000-1000-8000-00805f9b34fb",
  },
  {
    name: "Generic Chinese OEM 58mm",
    description: "Common fallback for many unbranded 58mm printers",
    serviceUuid: "0000ff00-0000-1000-8000-00805f9b34fb",
    characteristicUuid: "0000ff02-0000-1000-8000-00805f9b34fb",
  },
  {
    name: "KT6368A chip (Pro variants)",
    description: "Used in VSC Pro and dual-mode BLE/SPP printers",
    serviceUuid: "49535343-fe7d-4ae5-8fa9-9fafd205e455",
    characteristicUuid: "49535343-8841-43f4-a8d4-ecbe34729bb3",
  },
  {
    name: "BLE-only variant",
    description: "Some BLE-only VSC firmware versions",
    serviceUuid: "e7810a71-73ae-499d-8c15-faa9aef0c3f2",
    characteristicUuid: "bef8d6c9-9c21-4c9e-b632-bd58c1009f9f",
  },
];

/** All optional service UUIDs to declare when scanning (required by Web Bluetooth API) */
export const ALL_OPTIONAL_SERVICES: string[] = UUID_PRESETS.map(
  (p) => p.serviceUuid
);

/** Chunk size in bytes for BLE writes. The MP-58M Pro MTU is conservative. */
export const BLE_CHUNK_SIZE = 20;

/** Delay in ms between BLE write chunks. Prevents dropped data on the MP-58M Pro. */
export const BLE_CHUNK_DELAY_MS = 100;
